import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';

import ShowChartIcon from '@mui/icons-material/ShowChart';
import HistoryIcon from '@mui/icons-material/History';

// Operations > Load Testing opens here: a choice between watching a test that
// is running and looking back at past ones. Same cards as the Tools landing page.
const menuItems = [
  {
    label: 'Live Tests',
    description: 'Watch a load test as it runs',
    icon: <ShowChartIcon sx={{ fontSize: 48 }} />,
    path: '/operations/load-test/live',
    color: 'grey.800',
  },
  {
    label: 'Historical Data',
    description: 'Review and download past load tests',
    icon: <HistoryIcon sx={{ fontSize: 48 }} />,
    path: '/operations/load-test/history',
    color: 'grey.800',
  },
];

function LoadTestLandingPage() {
  const navigate = useNavigate();
  return (
    <Box>
      <Grid container spacing={3}>
        {menuItems.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.label}>
            <Card
              sx={{
                height: '100%',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardActionArea onClick={() => navigate(item.path)} sx={{ height: '100%', p: 2 }}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      backgroundColor: item.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mx: 'auto',
                      mb: 2,
                      color: 'white',
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography variant='h6' fontWeight={600} sx={{ mb: 1 }}>
                    {item.label}
                  </Typography>
                  <Typography variant='body2' fontStyle='italic' color='text.secondary'>
                    {item.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default LoadTestLandingPage;
